import React, { useState } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css'; // Import Quill's CSS
import "./customForm.styles.scss"

const QuillTextarea = ({ label, name, value, onChange, placeholder, required }) => {
  const handleQuillChange = (content) => {
    onChange({ target: { name, value: content } });
  };

  return (
    <div className="custom-form__field">
      <ReactQuill
        id={name}
        value={value}
        onChange={handleQuillChange}
        placeholder={placeholder}
        required={required}
        theme="snow"
        className="custom-form__textarea"
      />
    </div>
  );
}

export default QuillTextarea;
